import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder for outline sections.
//
// On drop we submit the whole form in the background (not just the order) so
// the server's stored JSON always matches what's on screen — otherwise any
// text you'd typed but not saved would get applied to the wrong section.
// Order is carried by the hidden section_order[] inputs, which move with
// their card, so array param order reflects the DOM order.
export default class extends Controller {
  static targets = ["list", "status"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-drag-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      onEnd: () => this.persist(),
    })
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  async persist() {
    this.renumber()

    const form = this.element.closest("form")
    if (!form) return

    this.setStatus("Saving order…")
    try {
      const response = await fetch(form.action, {
        method: "POST", // FormData carries _method=patch
        body: new FormData(form),
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
      this.setStatus(response.ok ? "Order saved" : "Couldn't save order")
    } catch (error) {
      console.error("Outline reorder failed", error)
      this.setStatus("Couldn't save order")
    }
  }

  // Keep the visible 1..n badges correct after a drag.
  renumber() {
    this.listTarget
      .querySelectorAll("[data-section-number]")
      .forEach((el, index) => {
        el.textContent = index + 1
      })
  }

  setStatus(text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
    clearTimeout(this.statusTimer)
    this.statusTimer = setTimeout(() => {
      this.statusTarget.textContent = ""
    }, 2000)
  }
}
